import { useState, useEffect } from 'react';
import './NetworkPage.css';
import CuratorModal from './CuratorModal';
import SnipersTab from './SnipersTab';
import CopytradeTab from './CopytradeTab';
import TrackerTab from './TrackerTab';
import WalletsTab from './WalletsTab';
import AnalyticsTab from './AnalyticsTab';
import AdminPanel from './AdminPanel';
import SettingsPage from './SettingsPage';
import { useCryptoPrices, fmtFooterPrice } from './useCryptoPrices';
import { useBotWallet } from './useBotWallet';
import { saveTelegramConfig, clearTelegramConfig, getTelegramStatus, testTelegram } from './bot/botLogger';
import { supabase } from './supabase';

const INITIAL_CURATORS = [
  { id:1, name:'DEGEN #1', tag:'EARLY_BUYER', handle:'@blockstep', followers:1, prix:20.0, subscribed:false, avatar:'D', avatarColor:'#1a3a5a', solde:'0.81', couverture:'0', abonnes:0, touxResultat24h:'0', tous24h:0, tauxMigration:'0.8', roiScore:1 },
  { id:2, name:'Monday MEMESCOPE', tag:'EARLY_BUYER', handle:'@monday', followers:1, prix:20.0, subscribed:true, avatar:'M', avatarColor:'#2a1a4a', solde:'28.38', couverture:'0', abonnes:1, touxResultat24h:'0', tous24h:0, tauxMigration:'0.0', roiScore:1 },
  { id:3, name:'FZ-LIMITLESS', tag:'EARLY_BUYER', handle:'@fzlimitless', followers:2, prix:12.0, subscribed:true, avatar:'F', avatarColor:'#1a3a2a', solde:'1.66', couverture:'0', abonnes:2, touxResultat24h:'0', tous24h:0, tauxMigration:'0.0', roiScore:2 },
  { id:4, name:'High wallet b', tag:'GROS_WALLET', handle:'@highwallet', followers:3, prix:15.0, subscribed:false, avatar:'H', avatarColor:'#3a2a1a', solde:'142.5', couverture:'0', abonnes:3, touxResultat24h:'0', tous24h:0, tauxMigration:'0.0', roiScore:5 },
];

const TAG_LABELS = { EARLY_BUYER:'EARLY BUYER', GROS_WALLET:'GROS WALLET', ACCUMULATEUR:'ACCUMULATEUR'};
const TAG_COLORS = { EARLY_BUYER:'#1a4a6a', GROS_WALLET:'#3a2a1a', ACCUMULATEUR:'#2a3a1a'};
let nextId = 5;

const RPC_URL = `https://mainnet.helius-rpc.com/?api-key=${localStorage.getItem('helius-api-key')||process.env.REACT_APP_HELIUS_API_KEY||''}`;

function UserMenu({ user, profile, onDisconnect, onOpenAdmin, onOpenSettings, onClose }) {
  const [changingPwd, setChangingPwd] = useState(false);
  const [newPwd, setNewPwd] = useState('');
  const [pwdMsg, setPwdMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChangePwd = async () => {
    if (!newPwd || newPwd.length < 6) return setPwdMsg('Min 6 caractères');
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password: newPwd });
    if (error) setPwdMsg('' + error.message);
    else { setPwdMsg('Mot de passe changé !'); setNewPwd(''); setTimeout(()=>setChangingPwd(false),2000); }
    setLoading(false);
  };

  return (
    <div style={{position:'fixed',inset:0,zIndex:600}} onClick={onClose}>
      <div style={{position:'absolute',top:52,right:16,width:280,background:'#0b0e14',border:'1px solid rgba(0,229,204,0.2)',borderRadius:12,boxShadow:'0 8px 40px rgba(0,0,0,0.8)',overflow:'hidden'}} onClick={e=>e.stopPropagation()}>
        <div style={{padding:'16px 18px',background:'linear-gradient(135deg,rgba(0,229,204,0.05),rgba(124,77,255,0.05))',borderBottom:'1px solid #1a2030'}}>
          <div style={{display:'flex',alignItems:'center',gap:12}}>
            <div style={{width:40,height:40,borderRadius:'50%',background:'linear-gradient(135deg,#00e5cc,#7c4dff)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:16,fontWeight:800,color:'#060809'}}>
              {user?.email?.charAt(0).toUpperCase()}
            </div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:12,fontWeight:700,color:'#e0e8f0',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{user?.email}</div>
<div style={{display:'flex',alignItems:'center',gap:6,marginTop:3,flexWrap:'wrap'}}>
  {profile?.is_admin && <span style={{fontSize:9,padding:'1px 6px',borderRadius:4,background:'rgba(124,77,255,0.15)',color:'#7c4dff',border:'1px solid #7c4dff33',fontWeight:700}}> ADMIN</span>}
  <span style={{fontSize:9,padding:'1px 6px',borderRadius:4,background:'rgba(0,229,204,0.1)',color:'#00e5cc',border:'1px solid #00e5cc22',fontWeight:700}}> Actif</span>
  {profile?.plan && profile.plan !== 'free'&& (
    <span style={{fontSize:9,padding:'1px 6px',borderRadius:4,background:'rgba(240,165,0,0.15)',color:'#f0a500',border:'1px solid #f0a50033',fontWeight:700,textTransform:'uppercase'}}>
      {profile.plan}
    </span>
  )}
  {profile?.plan_expires_at && (
    <span style={{fontSize:9,padding:'1px 6px',borderRadius:4,background:'rgba(90,106,128,0.15)',color:'#5a6a80',border:'1px solid #5a6a8022',fontWeight:700}}>
      {Math.ceil((new Date(profile.plan_expires_at) - new Date()) / (1000*60*60*24))}j restants
    </span>
  )}
</div>
            </div>
          </div>
        </div>

        <div style={{padding:'8px 0'}}>
          {profile?.is_admin && (
            <button onClick={()=>{onOpenAdmin();onClose();}}
              style={{width:'100%',padding:'10px 18px',background:'transparent',border:'none',color:'#7c4dff',fontSize:12,fontWeight:700,cursor:'pointer',display:'flex',alignItems:'center',gap:10,textAlign:'left'}}
              onMouseEnter={e=>e.currentTarget.style.background='rgba(124,77,255,0.08)'}
              onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
              <span style={{fontSize:14}}></span>
              <span>Panel Admin</span>
              <span style={{marginLeft:'auto',fontSize:9,padding:'1px 6px',borderRadius:8,background:'rgba(124,77,255,0.15)',color:'#7c4dff',border:'1px solid #7c4dff33'}}>ADMIN</span>
            </button>
          )}

          <div style={{height:1,background:'#1a2030',margin:'4px 0'}}/>

          <button onClick={()=>setChangingPwd(v=>!v)}
            style={{width:'100%',padding:'10px 18px',background:'transparent',border:'none',color:'#c0c8d8',fontSize:12,cursor:'pointer',display:'flex',alignItems:'center',gap:10,textAlign:'left'}}
            onMouseEnter={e=>e.currentTarget.style.background='rgba(255,255,255,0.03)'}
            onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
            <span style={{fontSize:14}}></span>
            <span>Changer le mot de passe</span>
          </button>

          {changingPwd && (
            <div style={{padding:'8px 18px',borderBottom:'1px solid #1a2030'}}>
              <input type="password"placeholder="Nouveau mot de passe"value={newPwd} onChange={e=>setNewPwd(e.target.value)}
                style={{width:'100%',background:'#0d1117',border:'1px solid #1e2a38',borderRadius:6,color:'#c0c8d8',fontSize:11,padding:'8px 10px',outline:'none',boxSizing:'border-box',marginBottom:6}}/>
              {pwdMsg&&<div style={{fontSize:10,color:pwdMsg.startsWith('')?'#00e5cc':'#ff6b6b',marginBottom:6}}>{pwdMsg}</div>}
              <button onClick={handleChangePwd} disabled={loading}
                style={{width:'100%',padding:'7px',borderRadius:6,background:'rgba(0,229,204,0.15)',border:'1px solid #00e5cc33',color:'#00e5cc',fontSize:11,fontWeight:700,cursor:'pointer'}}>
                {loading?'⏳...':'Confirmer'}
              </button>
            </div>
          )}

          <button
            style={{width:'100%',padding:'10px 18px',background:'transparent',border:'none',color:'#c0c8d8',fontSize:12,cursor:'pointer',display:'flex',alignItems:'center',gap:10,textAlign:'left'}}
            onMouseEnter={e=>e.currentTarget.style.background='rgba(255,255,255,0.03)'}
            onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
            <span style={{fontSize:14}}></span>
            <span>Mon profil</span>
          </button>

          {/*  Paramètres — ouvre SettingsPage */}
          <button onClick={()=>{onOpenSettings();onClose();}}
            style={{width:'100%',padding:'10px 18px',background:'transparent',border:'none',color:'#c0c8d8',fontSize:12,cursor:'pointer',display:'flex',alignItems:'center',gap:10,textAlign:'left'}}
            onMouseEnter={e=>e.currentTarget.style.background='rgba(255,255,255,0.03)'}
            onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
            <span style={{fontSize:14}}></span>
            <span>Paramètres</span>
          </button>

          <div style={{height:1,background:'#1a2030',margin:'4px 0'}}/>

          <button onClick={()=>{onDisconnect();onClose();}}
            style={{width:'100%',padding:'10px 18px',background:'transparent',border:'none',color:'#ff6b6b',fontSize:12,fontWeight:700,cursor:'pointer',display:'flex',alignItems:'center',gap:10,textAlign:'left'}}
            onMouseEnter={e=>e.currentTarget.style.background='rgba(255,107,107,0.06)'}
            onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
            <span style={{fontSize:14}}></span>
            <span>Se déconnecter</span>
          </button>
        </div>
      </div>
    </div>
  );
}

function WalletDropdown({ wallet, locked, hasWallet, loading, error, createWallet, importWallet, unlockWallet, lockWallet, deleteWallet, refreshBalance, onGoToCopytrade, walletList, balances, keypairs, setSimBalance, simBalance, solPrice = 150, profile }) {
  const [eurRate, setEurRate] = useState(0.92);
  useEffect(() => {
    fetch('https://api.frankfurter.app/latest?from=USD&to=EUR')
      .then(r => r.json()).then(j => { if (j?.rates?.EUR) setEurRate(j.rates.EUR); }).catch(() => {});
  }, []);
  const [view,         setView]         = useState('main');
  const [pwd,          setPwd]          = useState('');
  const [confirm,      setConfirm]      = useState('');
  const [privKeyInput, setPrivKeyInput] = useState('');
  const [showPrivKey,  setShowPrivKey]  = useState(false);
  const [decryptedKey, setDecryptedKey] = useState('');
  const [localError,   setLocalError]   = useState('');
  const [withdrawAddr, setWithdrawAddr] = useState('');
  const [withdrawAmt,  setWithdrawAmt]  = useState('');
  const [withdrawPwd,  setWithdrawPwd]  = useState('');
  const [withdrawing,  setWithdrawing]  = useState(false);
  const [withdrawDone, setWithdrawDone] = useState('');
  const [tgToken,      setTgToken]      = useState(() => getTelegramStatus().token || '');
  const [tgChatId,     setTgChatId]     = useState(() => getTelegramStatus().chatId || '');
  const [tgTesting,    setTgTesting]    = useState(false);
  const [tgResult,     setTgResult]     = useState(null);

  const [simInput,     setSimInput]     = useState('');
  const tgConfigured = getTelegramStatus().configured;

  const inp = { background:'#111827', border:'1px solid #1e2a38', borderRadius:6, color:'#c0c8d8', fontSize:12, padding:'8px 12px', width:'100%', outline:'none', boxSizing:'border-box', fontFamily:'inherit'};
  const btn = (color='#00e5cc') => ({ padding:'9px', borderRadius:6, background:`rgba(${color==='#00e5cc'?'0,229,204':color==='#7c4dff'?'124,77,255':color==='#ff6b6b'?'255,107,107':color==='#f0a500'?'240,165,0':'90,106,128'},0.15)`, border:`1px solid ${color}33`, color, fontSize:11, fontWeight:700, cursor:'pointer', width:'100%', fontFamily:'inherit', transition:'all 0.15s'});

  const handleCreate = async () => {
    if (pwd !== confirm) { setLocalError('Mots de passe différents'); return; }
    setLocalError('');
    const ok = await createWallet(pwd);
    if (ok) { setView('main'); setPwd(''); setConfirm(''); }
    else setLocalError(error || 'Erreur');
  };

  const handleImport = async () => {
    setLocalError('');
    const ok = await importWallet(privKeyInput, pwd);
    if (ok) { setView('main'); setPwd(''); setPrivKeyInput(''); }
    else setLocalError(error || 'Clé invalide');
  };

const handleShowKey = async () => {
  setLocalError('');
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user) throw new Error('Non connecté');
    const realWallets = (walletList||[]).filter(w => !w.isSim);
    if (!realWallets.length) throw new Error('Aucun wallet');
    const walletId = realWallets[0].id;
    const r = await fetch('https://copyccxx.com/api/wallet/privatekey', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${session.access_token}` },
      body: JSON.stringify({ walletId, userId: session.user.id }),
    });
    const j = await r.json();
    if (!j.success) throw new Error(j.error || 'Erreur');
    // Convertir en base58 (format Phantom / Solflare)
    try {
      const bs58 = (await import('bs58')).default;
      const raw = typeof j.privateKey === 'string' ? JSON.parse(j.privateKey) : j.privateKey;
      setDecryptedKey(bs58.encode(Uint8Array.from(raw)));
    } catch {
      setDecryptedKey(j.privateKey);
    }
    setShowPrivKey(true);
  } catch (e) { setLocalError(e.message); }
};
const handleWithdraw = async () => {
    setLocalError(''); setWithdrawDone('');
    if (!withdrawAddr || withdrawAddr.length < 32) { setLocalError('Adresse invalide'); return; }
    const amt = parseFloat(withdrawAmt);
    if (!amt || amt <= 0) { setLocalError('Montant invalide'); return; }
    if (!withdrawPwd) { setLocalError('Mot de passe requis'); return; }
    setWithdrawing(true);
    try {
      const { data: { session: initSession } } = await supabase.auth.getSession();
      if (!initSession?.user) throw new Error('Non connecté');
      const { error: authErr } = await supabase.auth.signInWithPassword({
        email: initSession.user.email,
        password: withdrawPwd,
      });
      if (authErr) throw new Error('Mot de passe incorrect — retrait annulé');
      const { data: { session } } = await supabase.auth.getSession();
      const realWallets = (walletList||[]).filter(w => !w.isSim);
      if (!realWallets.length) throw new Error('Aucun wallet');
      const walletId = realWallets[0].id;
      const r = await fetch('https://copyccxx.com/api/wallet/withdraw', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${session.access_token}` },
        body: JSON.stringify({ walletId, userId: session.user.id, toAddress: withdrawAddr, amountSol: amt }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.error || 'Erreur retrait');
      setWithdrawDone(j.signature);
      setWithdrawAddr(''); setWithdrawAmt(''); setWithdrawPwd('');
      refreshBalance();
    } catch(e) { setLocalError(e.message); }
    setWithdrawing(false);
  };
  const handleSaveTelegram = () => {
    if (!tgToken || !tgChatId) { setTgResult({ ok:false, error:'Token et Chat ID requis'}); return; }
    saveTelegramConfig({ token: tgToken.trim(), chatId: tgChatId.trim() });
    setTgResult({ ok:true, msg:'Sauvegardé !'});
    setTimeout(() => setTgResult(null), 3000);
  };

  const handleTestTelegram = async () => {
    setTgTesting(true); setTgResult(null);
    const result = await testTelegram();
    setTgResult(result);
    setTgTesting(false);
  };


  if (view === 'main') {
    const realWallets = (walletList||[]).filter(w => !w.isSim);
    return (
      <div style={{display:'flex',flexDirection:'column',gap:0}}>
        <div style={{marginBottom:14,background:'linear-gradient(135deg,rgba(124,77,255,0.06),rgba(124,77,255,0.03))',border:'1px solid #7c4dff22',borderRadius:10,padding:'10px 14px'}}>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:profile?.is_admin?10:0}}>
            <div style={{display:'flex',alignItems:'center',gap:8}}>
              <span style={{fontSize:14}}></span>
              <div>
                <div style={{fontSize:11,fontWeight:700,color:'#7c4dff'}}>Sim Wallet</div>
                <div style={{fontSize:9,color:'#5a6a80'}}>Mode entraînement</div>
              </div>
            </div>
            <div style={{display:'flex',alignItems:'center',gap:8}}>
              <span style={{fontSize:14,fontWeight:800,color:'#7c4dff',fontFamily:'monospace'}}>{(simBalance||0).toFixed(2)}</span>
              <span style={{fontSize:9,color:'#5a6a80'}}>SOL</span>
            </div>
          </div>
          {profile?.is_admin && (
            <div>
              <div style={{fontSize:9,color:'#7c4dff',marginBottom:6,letterSpacing:'0.8px'}}>ADMIN — MODIFIER LE SOLDE SIM</div>
              <div style={{display:'flex',gap:4,marginBottom:6}}>
                {['1','5','10','50','100'].map(v=>(
                  <button key={v} onClick={()=>setSimBalance(parseFloat(v))}
                    style={{flex:1,padding:'5px 0',borderRadius:4,background:'rgba(124,77,255,0.15)',border:'1px solid #7c4dff33',color:'#7c4dff',fontSize:10,fontWeight:700,cursor:'pointer'}}>{v}</button>
                ))}
              </div>
              <div style={{display:'flex',gap:6}}>
                <input type="number"placeholder="Solde personnalisé..."value={simInput}
                  onChange={e=>setSimInput(e.target.value)}
                  onKeyDown={e=>e.key==='Enter'&&simInput&&(setSimBalance(parseFloat(simInput)),setSimInput(''))}
                  style={{...inp,flex:1,padding:'6px 10px',fontSize:10}}/>
                <button onClick={()=>{if(simInput){setSimBalance(parseFloat(simInput));setSimInput('');}}}
                  style={{padding:'6px 12px',borderRadius:6,background:'rgba(124,77,255,0.2)',border:'1px solid #7c4dff44',color:'#7c4dff',fontSize:10,fontWeight:700,cursor:'pointer',flexShrink:0}}>Définir</button>
              </div>
            </div>
          )}
        </div>
        {realWallets.length > 0 && realWallets.map(w => {
          const bal = (balances||{})[w.id] || 0;
          const isUnlocked = keypairs && keypairs[w.id];
          const isActive = wallet?.id === w.id;
          return (
            <div key={w.id} style={{marginBottom:12,background:isActive?'linear-gradient(135deg,#0d1117,#111827)':'#0d1117',border:`1px solid ${isActive?'#00e5cc33':'#1a2030'}`,borderRadius:10,padding:'12px 14px'}}>
              <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:10}}>
                <div style={{display:'flex',alignItems:'center',gap:8}}>
                  <div style={{width:28,height:28,borderRadius:6,background:'linear-gradient(135deg,#00e5cc22,#7c4dff22)',border:'1px solid #00e5cc33',display:'flex',alignItems:'center',justifyContent:'center',fontSize:14}}></div>
                  <div>
                    <div style={{fontSize:11,fontWeight:700,color:'#e0e4ec'}}>{w.name}</div>
                    <div style={{fontSize:9,color:'#5a6a80',fontFamily:'monospace'}}>{w.address.slice(0,8)}...{w.address.slice(-4)}</div>
                  </div>
                </div>
                <div style={{display:'flex',alignItems:'center',gap:6}}>
<span style={{width:6,height:6,borderRadius:'50%',background:'#00e5cc',display:'inline-block',boxShadow:'0 0 6px #00e5cc',animation:'pulse 2s infinite'}}/>
<span style={{fontSize:10,color:'#00e5cc',fontWeight:700}}>ACTIF</span>
                </div>
              </div>
              <div style={{textAlign:'center',padding:'10px 0',marginBottom:10}}>
                <div style={{fontSize:24,fontWeight:800,color:'#e0e4ec',fontFamily:'monospace'}}>{bal.toFixed(4)}</div>
                <div style={{fontSize:10,color:'#5a6a80'}}>SOL</div>
                <div style={{fontSize:11,color:'#5a6a80',marginTop:4}}>${(bal * solPrice).toFixed(2)} <span style={{color:'#3a4a5a'}}>·</span> €{(bal * solPrice * eurRate).toFixed(2)}</div>
                <button onClick={()=>refreshBalance(w.id)} style={{marginTop:6,padding:'3px 12px',borderRadius:20,background:'transparent',border:'1px solid #1a2030',color:'#5a6a80',fontSize:9,cursor:'pointer'}}>↻ Actualiser</button>
              </div>
              <div style={{background:'#090c12',border:'1px solid #1a2030',borderRadius:6,padding:'6px 10px',display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:10}}>
                <span style={{fontSize:9,color:'#5a6a80',fontFamily:'monospace',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',flex:1}}>{w.address}</span>
                <button onClick={()=>navigator.clipboard?.writeText(w.address)} style={{background:'none',border:'none',color:'#00e5cc',cursor:'pointer',marginLeft:6,fontSize:10,flexShrink:0}}></button>
              </div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:6}}>
                <button onClick={()=>setView('deposit')} style={{...btn('#00e5cc'),padding:'8px',fontSize:11}}>↓ DÉPOSER</button>
                <button onClick={()=>{setView('withdraw');setLocalError('');setWithdrawDone('');setWithdrawPwd('');}} style={{...btn('#7c4dff'),padding:'8px',fontSize:11}}>↑ RETIRER</button>
              </div>
              <a href={'https://solscan.io/account/'+w.address} target="_blank"rel="noopener noreferrer"style={{fontSize:10,color:'#5a6a80',textAlign:'center',display:'block',marginTop:8,textDecoration:'none'}}>Voir sur Solscan →</a>
            </div>
          );
        })}
        {realWallets.length === 0 && (
          <div style={{textAlign:'center',padding:'16px 0',marginBottom:12}}>
            <div style={{fontSize:13,fontWeight:700,color:'#e0e4ec',marginBottom:6}}>Aucun wallet réel</div>
            <div style={{fontSize:11,color:'#5a6a80',lineHeight:1.7}}>Crée ou importe un wallet pour trader avec de vrais SOL.</div>
          </div>
        )}
        <div style={{height:1,background:'#1a2030',marginBottom:12}}/>
        <div style={{display:'flex',flexDirection:'column',gap:6}}>
          <button onClick={()=>{setView('showkey');setDecryptedKey('');setShowPrivKey(false);setLocalError('');}}
            style={{...btn('#5a6a80'),textAlign:'left',padding:'8px 12px',display:'flex',alignItems:'center',gap:8}}>
             <span>Clé privée</span>
          </button>
          <button onClick={()=>setView('telegram')}
            style={{...btn(tgConfigured?'#00e5cc':'#5a6a80'),textAlign:'left',padding:'8px 12px',display:'flex',alignItems:'center',gap:8,justifyContent:'space-between'}}>
            <span style={{display:'flex',alignItems:'center',gap:8}}> <span>Alertes Telegram</span></span>
            <span style={{fontSize:9,padding:'1px 6px',borderRadius:8,background:tgConfigured?'rgba(0,229,204,0.2)':'rgba(90,106,128,0.2)',color:tgConfigured?'#00e5cc':'#5a6a80',border:`1px solid ${tgConfigured?'#00e5cc44':'#5a6a8044'}`}}>
              {tgConfigured?'ACTIF':'NON CONFIG'}
            </span>
          </button>
          <button onClick={onGoToCopytrade}
            style={{...btn('#00e5cc'),textAlign:'left',padding:'8px 12px',display:'flex',alignItems:'center',gap:8}}>
             <span>Aller au Copytrade</span>
          </button>
        </div>
        <div style={{height:1,background:'#1a2030',margin:'12px 0'}}/>
        <button onClick={()=>{setPwd('');setConfirm('');setLocalError('');setView('create');}}
          style={{...btn('#5a6a80'),textAlign:'left',padding:'8px 12px',display:'flex',alignItems:'center',gap:8,marginBottom:6}}>
          + <span>Créer un wallet</span>
        </button>
        <button onClick={()=>{setPwd('');setPrivKeyInput('');setLocalError('');setView('import');}}
          style={{...btn('#5a6a80'),textAlign:'left',padding:'8px 12px',display:'flex',alignItems:'center',gap:8}}>
           <span>Importer un wallet</span>
        </button>
        {realWallets.length > 0 && (
          <div style={{marginTop:16,paddingTop:12,borderTop:'1px solid #1a2030'}}>
            <button onClick={()=>{if(window.confirm(
              'Ce wallet sera masqué de ton interface.\n\n' +
              'Tes fonds resteront en sécurité côté serveur, mais tu devras contacter le support pour y accéder à nouveau.\n\n' +
              'As-tu sauvegardé ta clé privée si tu veux y accéder toi-même plus tard ?'
            ))deleteWallet(realWallets[0]?.id);}}
              style={{...btn('#ff6b6b'),padding:'7px 12px',fontSize:10,opacity:0.7}}
              onMouseEnter={e=>e.currentTarget.style.opacity='1'}
              onMouseLeave={e=>e.currentTarget.style.opacity='0.7'}>
               Supprimer le wallet
            </button>
          </div>
        )}
      </div>
    );
  }

  if (view === 'deposit') {
    return (
      <div style={{display:'flex',flexDirection:'column',gap:12}}>
        <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
          <button onClick={()=>setView('main')} style={{background:'none',border:'none',color:'#5a6a80',cursor:'pointer',fontSize:16}}>←</button>
          <span style={{fontSize:13,fontWeight:700,color:'#e0e4ec'}}>↓ Déposer des SOL</span>
        </div>
        <div style={{background:'rgba(0,229,204,0.05)',border:'1px solid rgba(0,229,204,0.2)',borderRadius:8,padding:16,textAlign:'center'}}>
          <div style={{fontSize:10,color:'#5a6a80',marginBottom:8}}>Envoie des SOL à cette adresse</div>
          <div style={{fontSize:11,color:'#00e5cc',fontFamily:'monospace',wordBreak:'break-all',lineHeight:1.6,padding:'8px',background:'#0d1117',borderRadius:6,border:'1px solid #00e5cc22'}}>{wallet?.address}</div>
          <button onClick={()=>navigator.clipboard?.writeText(wallet?.address||'')}
            style={{marginTop:12,padding:'8px 20px',borderRadius:6,background:'rgba(0,229,204,0.15)',border:'1px solid #00e5cc33',color:'#00e5cc',fontSize:12,fontWeight:700,cursor:'pointer'}}> Copier l'adresse</button>
        </div>
        <button onClick={()=>refreshBalance()} style={{...btn('#00e5cc')}}>↻ Vérifier le solde</button>
        <button onClick={()=>setView('main')} style={btn('#5a6a80')}>← Retour</button>
      </div>
    );
  }

  if (view === 'telegram') {
    const getUpdatesUrl = tgToken ? 'https://api.telegram.org/bot'+tgToken+'/getUpdates': 'https://api.telegram.org/bot/getUpdates';
    const getUpdatesLabel = tgToken ? 'api.telegram.org/bot'+tgToken.slice(0,20)+'.../getUpdates': 'api.telegram.org/bot[TON_TOKEN]/getUpdates';
    return (
      <div style={{display:'flex',flexDirection:'column',gap:12}}>
        <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
          <button onClick={()=>setView('main')} style={{background:'none',border:'none',color:'#5a6a80',cursor:'pointer',fontSize:16}}>←</button>
          <span style={{fontSize:13,fontWeight:700,color:'#e0e4ec'}}> Alertes Telegram</span>
        </div>
        <div style={{background:'rgba(0,229,204,0.05)',border:'1px solid rgba(0,229,204,0.2)',borderRadius:8,padding:12}}>
          <div style={{fontSize:11,fontWeight:700,color:'#00e5cc',marginBottom:8}}> Comment configurer</div>
          <div style={{fontSize:11,color:'#c0c8d8',lineHeight:1.9}}>
            <div><span style={{color:'#00e5cc',fontWeight:700}}>1.</span> Cherche <strong style={{color:'#00e5cc'}}>@BotFather</strong> sur Telegram</div>
            <div><span style={{color:'#00e5cc',fontWeight:700}}>2.</span> Tape <code style={{background:'#0d1117',padding:'1px 5px',borderRadius:3}}>/newbot</code></div>
            <div><span style={{color:'#00e5cc',fontWeight:700}}>3.</span> Copie le Token reçu ci-dessous</div>
            <div><span style={{color:'#00e5cc',fontWeight:700}}>4.</span> Envoie un message à ton bot puis ouvre :</div>
          </div>
          <a href={getUpdatesUrl} target="_blank"rel="noreferrer"style={{display:'block',marginTop:6,fontSize:10,color:'#00e5cc',textDecoration:'none',background:'rgba(0,229,204,0.08)',border:'1px solid #00e5cc22',borderRadius:4,padding:'5px 10px',wordBreak:'break-all'}}>{getUpdatesLabel} ↗</a>
        </div>
        <div>
          <div style={{fontSize:10,color:'#5a6a80',marginBottom:5,textTransform:'uppercase',letterSpacing:'0.8px'}}>Token Telegram</div>
          <input style={inp} placeholder="1234567890:AAFxK9m..."value={tgToken} onChange={e=>setTgToken(e.target.value)}/>
        </div>
        <div>
          <div style={{fontSize:10,color:'#5a6a80',marginBottom:5,textTransform:'uppercase',letterSpacing:'0.8px'}}>Chat ID</div>
          <input style={inp} placeholder="123456789"value={tgChatId} onChange={e=>setTgChatId(e.target.value)}/>
        </div>
        {tgResult&&(
          <div style={{padding:'8px 12px',borderRadius:6,background:tgResult.ok?'rgba(0,229,204,0.08)':'rgba(255,107,107,0.08)',border:`1px solid ${tgResult.ok?'#00e5cc33':'#ff6b6b33'}`,fontSize:11,color:tgResult.ok?'#00e5cc':'#ff6b6b'}}>
            {tgResult.ok ? ''+(tgResult.msg||'Envoyé !') : ''+tgResult.error}
          </div>
        )}
        <div style={{display:'flex',gap:8}}>
          <button onClick={()=>setView('main')} style={{...btn('#5a6a80'),flex:1}}>Annuler</button>
          <button onClick={handleSaveTelegram} disabled={!tgToken||!tgChatId} style={{...btn('#00e5cc'),flex:1,opacity:!tgToken||!tgChatId?0.5:1}}> Sauvegarder</button>
        </div>
        <button onClick={handleTestTelegram} disabled={tgTesting||!tgToken||!tgChatId} style={{...btn('#7c4dff'),opacity:tgTesting||!tgToken||!tgChatId?0.5:1}}>
          {tgTesting?'⏳ Envoi...':'Tester'}
        </button>
        {tgConfigured&&<button onClick={()=>{clearTelegramConfig();setTgToken('');setTgChatId('');}} style={{...btn('#ff6b6b'),fontSize:10}}> Supprimer</button>}
      </div>
    );
  }

  if (view === 'withdraw') {
    return (
      <div style={{display:'flex',flexDirection:'column',gap:12}}>
        <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
          <button onClick={()=>{setView('main');setLocalError('');setWithdrawDone('');}} style={{background:'none',border:'none',color:'#5a6a80',cursor:'pointer',fontSize:16}}>←</button>
          <span style={{fontSize:13,fontWeight:700,color:'#e0e4ec'}}>↑ Retirer des fonds</span>
        </div>
        <div style={{background:'#0d1117',border:'1px solid #1a2030',borderRadius:8,padding:'12px',textAlign:'center'}}>
          <div style={{fontSize:11,color:'#5a6a80',marginBottom:4}}>Solde disponible</div>
          <div style={{fontSize:22,fontWeight:800,color:'#e0e4ec'}}>{wallet?.balance.toFixed(4)} <span style={{fontSize:13,color:'#5a6a80'}}>SOL</span></div>
        </div>
        {withdrawDone&&(
          <div style={{background:'rgba(0,229,204,0.08)',border:'1px solid rgba(0,229,204,0.3)',borderRadius:8,padding:'12px',textAlign:'center'}}>
            <div style={{fontSize:12,fontWeight:700,color:'#00e5cc',marginBottom:6}}> Retrait envoyé !</div>
            <a href={'https://solscan.io/tx/'+withdrawDone} target="_blank"rel="noreferrer"style={{fontSize:10,color:'#00e5cc',textDecoration:'none',background:'rgba(0,229,204,0.08)',border:'1px solid #00e5cc22',borderRadius:4,padding:'4px 10px',display:'inline-block'}}>Voir la transaction ↗</a>
          </div>
        )}
        <div>
          <div style={{fontSize:10,color:'#5a6a80',marginBottom:5,textTransform:'uppercase',letterSpacing:'0.8px'}}>Adresse de destination</div>
          <input style={inp} placeholder="Adresse Solana..."value={withdrawAddr} onChange={e=>setWithdrawAddr(e.target.value)}/>
        </div>
        <div>
          <div style={{fontSize:10,color:'#5a6a80',marginBottom:5,textTransform:'uppercase',letterSpacing:'0.8px'}}>Montant (SOL)</div>
          <div style={{display:'flex',gap:4,marginBottom:6}}>
            {['0.1','0.5','1','MAX'].map(v=>(
              <button key={v} onClick={()=>setWithdrawAmt(v==='MAX'?Math.max(0,(wallet?.balance||0)-0.001).toFixed(4):v)}
                style={{flex:1,padding:'5px 0',borderRadius:4,background:'#0d1117',border:'1px solid #1a2030',color:'#5a6a80',fontSize:11,fontWeight:700,cursor:'pointer'}}>{v}</button>
            ))}
          </div>
          <div style={{display:'flex'}}>
            <input style={{...inp,borderRadius:'6px 0 0 6px',borderRight:'none'}} type="number"placeholder="0.00"value={withdrawAmt} onChange={e=>setWithdrawAmt(e.target.value)}/>
            <div style={{background:'#1a2030',border:'1px solid #1e2a38',borderRadius:'0 6px 6px 0',padding:'8px 12px',color:'#5a6a80',fontSize:11}}>SOL</div>
          </div>
        </div>

        <div>
          <div style={{fontSize:10,color:'#5a6a80',marginBottom:5,textTransform:'uppercase',letterSpacing:'0.8px'}}>Confirmation — Mot de passe</div>
          <input style={inp} type="password" placeholder="Mot de passe du compte" value={withdrawPwd} onChange={e=>setWithdrawPwd(e.target.value)} onKeyDown={e=>e.key==='Enter'&&handleWithdraw()}/>
        </div>
        <div style={{background:'rgba(255,107,107,0.05)',border:'1px solid rgba(255,107,107,0.2)',borderRadius:6,padding:'8px 12px',fontSize:10,color:'#ff9b6b'}}>
           Les transactions Solana sont irréversibles.
        </div>
        {localError&&<div style={{fontSize:11,color:'#ff6b6b'}}>{localError}</div>}
        <div style={{display:'flex',gap:8}}>
          <button onClick={()=>{setView('main');setLocalError('');setWithdrawPwd('');}} style={{...btn('#5a6a80'),flex:1}}>Annuler</button>
          <button onClick={handleWithdraw} disabled={withdrawing||!withdrawAddr||!withdrawAmt||!withdrawPwd}
            style={{...btn('#7c4dff'),flex:2,opacity:withdrawing||!withdrawAddr||!withdrawAmt||!withdrawPwd?0.5:1}}>
            {withdrawing?'⏳ Envoi...':'↑ Envoyer'}
          </button>
        </div>
      </div>
    );
  }

  if (view === 'showkey') {
    return (
      <div style={{display:'flex',flexDirection:'column',gap:12}}>
        <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
          <button onClick={()=>setView('main')} style={{background:'none',border:'none',color:'#5a6a80',cursor:'pointer',fontSize:16}}>←</button>
          <span style={{fontSize:13,fontWeight:700,color:'#e0e4ec'}}> Clé privée</span>
        </div>
        <div style={{background:'rgba(255,107,107,0.08)',border:'1px solid rgba(255,107,107,0.3)',borderRadius:8,padding:12,fontSize:11,color:'#c0c8d8',lineHeight:1.7}}>
           Ne partage <strong>jamais</strong> ta clé privée.
        </div>
        {!showPrivKey ? (
          <>
            <div style={{background:'rgba(255,107,107,0.12)',border:'1px solid rgba(255,107,107,0.4)',borderRadius:8,padding:'10px 12px',fontSize:11,color:'#c0c8d8',lineHeight:1.8}}>
              ⚠ Cette clé donne un accès <strong>total</strong> à ce wallet et à tous ses fonds.<br/>
              Ne la partage avec personne, même en cas de demande d'assistance.
            </div>
            {localError&&<div style={{fontSize:11,color:'#ff6b6b'}}>{localError}</div>}
            <div style={{display:'flex',gap:8}}>
              <button onClick={()=>setView('main')} style={{...btn('#5a6a80'),flex:1}}>Annuler</button>
              <button onClick={handleShowKey} style={{...btn('#ff6b6b'),flex:1}}>Je comprends — afficher</button>
            </div>
          </>
        ) : (
          <>
            <div style={{background:'#0d1117',border:'1px solid #ff6b6b33',borderRadius:6,padding:'10px 12px',fontSize:10,color:'#ff6b6b',fontFamily:'monospace',wordBreak:'break-all',lineHeight:1.6}}>{decryptedKey}</div>
            <button onClick={()=>navigator.clipboard?.writeText(decryptedKey)} style={btn('#ff6b6b')}> Copier</button>
            <button onClick={()=>{setShowPrivKey(false);setDecryptedKey('');setView('main');}} style={btn('#5a6a80')}> Fermer</button>
          </>
        )}
      </div>
    );
  }

  if (view === 'create') {
    return (
      <div style={{display:'flex',flexDirection:'column',gap:12}}>
        <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
          <button onClick={()=>setView('main')} style={{background:'none',border:'none',color:'#5a6a80',cursor:'pointer',fontSize:16}}>←</button>
          <span style={{fontSize:13,fontWeight:700,color:'#e0e4ec'}}> Créer un wallet</span>
        </div>
        <div style={{background:'rgba(0,229,204,0.05)',border:'1px solid rgba(0,229,204,0.15)',borderRadius:8,padding:10,fontSize:11,color:'#5a8a7a',lineHeight:1.6}}>
          Un nouveau wallet Solana sera généré. <strong style={{color:'#00e5cc'}}>Note bien ta clé privée !</strong>
        </div>
        <div>
          <div style={{fontSize:10,color:'#5a6a80',marginBottom:5,textTransform:'uppercase'}}>Mot de passe</div>
          <input style={inp} type="password"placeholder="Min 6 caractères"value={pwd} onChange={e=>setPwd(e.target.value)} autoFocus/>
        </div>
        <div>
          <div style={{fontSize:10,color:'#5a6a80',marginBottom:5,textTransform:'uppercase'}}>Confirmer</div>
          <input style={inp} type="password"placeholder="Répète le mot de passe"value={confirm} onChange={e=>setConfirm(e.target.value)}/>
        </div>
        {pwd&&confirm&&pwd!==confirm&&<div style={{fontSize:11,color:'#ff6b6b'}}>Les mots de passe ne correspondent pas</div>}
        {localError&&<div style={{fontSize:11,color:'#ff6b6b'}}>{localError}</div>}
        <div style={{display:'flex',gap:8}}>
          <button onClick={()=>setView('main')} style={{...btn('#5a6a80'),flex:1}}>Annuler</button>
          <button onClick={handleCreate} disabled={loading||pwd!==confirm||!pwd} style={{...btn('#00e5cc'),flex:1,opacity:loading||pwd!==confirm||!pwd?0.5:1}}>{loading?'…':'Créer'}</button>
        </div>
      </div>
    );
  }

  if (view === 'import') {
    return (
      <div style={{display:'flex',flexDirection:'column',gap:12}}>
        <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
          <button onClick={()=>setView('main')} style={{background:'none',border:'none',color:'#5a6a80',cursor:'pointer',fontSize:16}}>←</button>
          <span style={{fontSize:13,fontWeight:700,color:'#e0e4ec'}}> Importer un wallet</span>
        </div>
        <div style={{background:'rgba(255,107,107,0.05)',border:'1px solid rgba(255,107,107,0.2)',borderRadius:8,padding:10,fontSize:11,color:'#ff9b6b',lineHeight:1.6}}>
           N'importe <strong>jamais</strong> ta clé Phantom principale ici.
        </div>
        <div>
          <div style={{fontSize:10,color:'#5a6a80',marginBottom:5,textTransform:'uppercase'}}>Clé privée</div>
          <textarea style={{...inp,minHeight:70,resize:'vertical'}} placeholder="Base64 ou tableau JSON [...]"value={privKeyInput} onChange={e=>setPrivKeyInput(e.target.value)}/>
        </div>
        <div>
          <div style={{fontSize:10,color:'#5a6a80',marginBottom:5,textTransform:'uppercase'}}>Mot de passe</div>
          <input style={inp} type="password"placeholder="Min 6 caractères"value={pwd} onChange={e=>setPwd(e.target.value)}/>
        </div>
        {localError&&<div style={{fontSize:11,color:'#ff6b6b'}}>{localError}</div>}
        <div style={{display:'flex',gap:8}}>
          <button onClick={()=>setView('main')} style={{...btn('#5a6a80'),flex:1}}>Annuler</button>
          <button onClick={handleImport} disabled={loading||!privKeyInput||!pwd} style={{...btn('#7c4dff'),flex:1,opacity:loading||!privKeyInput||!pwd?0.5:1}}>{loading?'…':'Importer'}</button>
        </div>
      </div>
    );
  }

  return null;
}export default function NetworkPage({ walletAddress, onDisconnect, onGoHome, user, profile, onOpenAdmin }) {
  const [activeTab,      setActiveTab]      = useState('network');
  const [activeNav,      setActiveNav]      = useState('feed');
  const [feedTab,        setFeedTab]        = useState('recent');
  const [filterType,     setFilterType]     = useState('tous');
  const [filterRisque,   setFilterRisque]   = useState('tous');
  const [minRoi,         setMinRoi]         = useState(0);
  const [searchQuery,    setSearchQuery]    = useState('');
  const [curators,       setCurators]       = useState(INITIAL_CURATORS);
  const [modalOpen,      setModalOpen]      = useState(false);
  const [editingCurator, setEditingCurator] = useState(null);
  const [deleteConfirm,  setDeleteConfirm]  = useState(null);
  const [manageMode,     setManageMode]     = useState(false);
  const [toast,          setToast]          = useState('');
  const [headerSearch,   setHeaderSearch]   = useState('');
  const [pendingAddr,      setPendingAddr]      = useState(null);
  const [pendingWalletAddr,setPendingWalletAddr]= useState(null);
  const [showWalletPanel,setShowWalletPanel]= useState(false);
  const [showUserMenu,   setShowUserMenu]   = useState(false);
  const [showAdminPanel, setShowAdminPanel] = useState(false);
  const [showSettings,   setShowSettings]   = useState(false);
  const [savedPwd,       setSavedPwd]       = useState('');
  const [autoUnlockAttempted, setAutoUnlockAttempted] = useState(false);

  const prices  = useCryptoPrices();
  const devMode = !walletAddress;

  const {
    wallet, locked, hasWallet, loading, error,
    createWallet, importWallet, unlockWallet, lockWallet, deleteWallet, refreshBalance,
    walletList, balances, keypairs, activeKeypair, isSim, setSimBalance, simBalance,
  } = useBotWallet();

  useEffect(() => {
    if (hasWallet && locked && !autoUnlockAttempted) {
      setAutoUnlockAttempted(true);
      const p = savedPwd || localStorage.getItem('wallet-password') || '';
      if (p) { setSavedPwd(p); unlockWallet(p); }
    }
  }, [hasWallet, locked, autoUnlockAttempted, savedPwd, unlockWallet]);

  const handleGlobalSearch  = (val) => { const trimmed=val.trim(); if(!trimmed)return; setPendingAddr(trimmed); setActiveTab('tracker'); setHeaderSearch(''); };
  const handleAnalyzeWallet = (addr) => { setPendingWalletAddr(addr); setActiveTab('wallets'); };
  const showToast = (msg) => { setToast(msg); setTimeout(()=>setToast(''),2500); };
  const handleAdd  = () => { setEditingCurator(null); setModalOpen(true); };
  const handleEdit = (c) => { setEditingCurator(c); setModalOpen(true); };
  const handleDelete = (id) => setDeleteConfirm(id);
  const confirmDelete = () => { setCurators(prev=>prev.filter(c=>c.id!==deleteConfirm)); setDeleteConfirm(null); showToast('Curateur supprimé'); };
  const handleSave = (data) => {
    if (editingCurator) { setCurators(prev=>prev.map(c=>c.id===editingCurator.id?{...c,...data}:c)); showToast('Curateur mis à jour'); }
    else { setCurators(prev=>[...prev,{...data,id:nextId++,subscribed:false,abonnes:0,touxResultat24h:'0',tous24h:0,followers:0}]); showToast('Curateur ajouté'); }
    setModalOpen(false); setEditingCurator(null);
  };
  const handleSubscribe = (id) => setCurators(prev=>prev.map(c=>c.id===id?{...c,subscribed:!c.subscribed}:c));

  const filtered = curators.filter(c => {
    if (searchQuery && !c.name.toLowerCase().includes(searchQuery.toLowerCase()) && !c.handle.toLowerCase().includes(searchQuery.toLowerCase())) return false;
    if (filterType!=='tous') { const map={early:'EARLY_BUYER',gros:'GROS_WALLET',acc:'ACCUMULATEUR'}; if(c.tag!==map[filterType])return false; }
    if (c.roiScore<minRoi) return false;
    return true;
  }).sort((a,b)=>feedTab==='populaire'?b.followers-a.followers:feedTab==='ancien'?a.id-b.id:b.id-a.id);

  const totalAbonnes = curators.reduce((s,c)=>s+c.abonnes,0);
  const topRoi = [...curators].sort((a,b)=>b.roiScore-a.roiScore).slice(0,4);
  const realWallets = (walletList||[]).filter(w => !w.isSim);

  return (
    <div className="net-root">
      {modalOpen&&<CuratorModal curator={editingCurator} onSave={handleSave} onClose={()=>{setModalOpen(false);setEditingCurator(null);}}/>}
      {deleteConfirm&&(
        <div className="confirm-overlay"onClick={()=>setDeleteConfirm(null)}>
          <div className="confirm-box"onClick={e=>e.stopPropagation()}>
            <div className="confirm-title">Supprimer ce curateur ?</div>
            <div className="confirm-sub">Cette action est irréversible.</div>
            <div className="confirm-actions">
              <button className="confirm-cancel"onClick={()=>setDeleteConfirm(null)}>Annuler</button>
              <button className="confirm-delete"onClick={confirmDelete}>Supprimer</button>
            </div>
          </div>
        </div>
      )}
      {toast&&<div className="net-toast">{toast}</div>}

      {/*  Admin Panel */}
      {showAdminPanel && profile?.is_admin && (
        <AdminPanel
          user={user}
          onClose={()=>setShowAdminPanel(false)}
          onImpersonate={(targetUser) => {
            setShowAdminPanel(false);
            if (onOpenAdmin) onOpenAdmin(targetUser);
          }}
        />
      )}

      {/*  Settings Page */}
      {showSettings && (
        <SettingsPage
          user={user}
          profile={profile}
          onClose={()=>setShowSettings(false)}
          onProfileUpdate={()=>{}}
        />
      )}

      {/*  Menu utilisateur */}
      {showUserMenu && (
        <UserMenu
          user={user}
          profile={profile}
          onDisconnect={onDisconnect}
          onOpenAdmin={()=>{ setShowAdminPanel(true); setShowUserMenu(false); }}
          onOpenSettings={()=>{ setShowSettings(true); setShowUserMenu(false); }}
          onClose={()=>setShowUserMenu(false)}
        />
      )}

      {showWalletPanel&&(
        <div style={{position:'fixed',inset:0,zIndex:500}} onClick={()=>setShowWalletPanel(false)}>
          <div style={{position:'absolute',top:52,right:16,width:320,background:'#0b0e14',border:'1px solid rgba(0,229,204,0.2)',borderRadius:12,boxShadow:'0 8px 40px rgba(0,0,0,0.7)',padding:18,maxHeight:'85vh',overflowY:'auto'}} onClick={e=>e.stopPropagation()}>
            <WalletDropdown
              wallet={wallet} locked={locked} hasWallet={hasWallet} loading={loading} error={error}
              createWallet={createWallet} importWallet={importWallet} unlockWallet={unlockWallet}
              lockWallet={lockWallet} deleteWallet={deleteWallet} refreshBalance={refreshBalance}
              onGoToCopytrade={()=>{setShowWalletPanel(false);setActiveTab('copytrade');}}
              walletList={walletList} balances={balances} keypairs={keypairs}
              setSimBalance={setSimBalance} simBalance={simBalance}
              profile={profile}
              solPrice={prices.sol || 150}
            />
          </div>
        </div>
      )}

      <header className="net-header">
        <div className="net-header-left">
          <button className="net-logo" onClick={()=>setActiveTab('network')} title="Accueil">
            <svg viewBox="0 0 28 28" width="22" height="22" style={{marginRight:7,verticalAlign:'middle',flexShrink:0}}>
              <defs>
                <linearGradient id="logoG" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#7c4dff"/>
                  <stop offset="100%" stopColor="#00e5cc"/>
                </linearGradient>
              </defs>
              <polygon points="14,1 25,7.5 25,20.5 14,27 3,20.5 3,7.5" fill="#0d1117" stroke="url(#logoG)" strokeWidth="1.5"/>
              <path d="M15 6l-5 9h5l-1 7 5-9h-5z" fill="url(#logoG)"/>
            </svg>
            <span style={{color:'#c0c8d8',fontWeight:500,letterSpacing:'0.5px'}}>COPY</span><span style={{background:'linear-gradient(90deg,#7c4dff,#00e5cc)',WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent',fontWeight:900,letterSpacing:'1px'}}>CCXX</span>
          </button>
          <nav className="net-tabs">
            {[
              ['network','Snipers'],
              ['copytrade','Copytrade'],
              ['tracker','Tracker'],
              ['wallets','Analyseur de Wallets'],
              ['analytics','Analytics'],
            ].map(([key,label])=>(
              <button key={key} className={`net-tab ${activeTab===key?'active':''}`} onClick={()=>setActiveTab(key)}>
                {label}
              </button>
            ))}
          </nav>
        </div>
        <div className="net-header-right">
          <div className="net-search-bar">
            <svg viewBox="0 0 16 16"fill="none"width="13"height="13"><circle cx="7"cy="7"r="5"stroke="#555"strokeWidth="1.4"/><path d="M11 11l3 3"stroke="#555"strokeWidth="1.4"strokeLinecap="round"/></svg>
            <input placeholder="Adresse du token…"value={headerSearch} onChange={e=>setHeaderSearch(e.target.value)} onKeyDown={e=>e.key==='Enter'&&handleGlobalSearch(e.target.value)}/>
            {headerSearch?<button className="net-search-go"onClick={()=>handleGlobalSearch(headerSearch)}>↵</button>:<span className="net-kbd">⌘/</span>}
          </div>
          <div className="net-price-pills">
            <div style={{display:'flex',alignItems:'center',gap:4,padding:'4px 10px',borderRadius:20,background:'rgba(124,77,255,0.06)',border:'1px solid #7c4dff22'}}>
              <span style={{fontSize:10}}></span>
              <span style={{fontSize:9,color:'#7c4dff',fontWeight:700}}>SIM</span>
              <span style={{fontSize:10,color:'#7c4dff',fontWeight:800,fontFamily:'monospace'}}>{(simBalance||0).toFixed(1)}</span>
            </div>
            <div onClick={()=>setShowWalletPanel(p=>!p)}
              style={{display:'flex',alignItems:'center',gap:5,padding:'4px 10px',borderRadius:20,background:showWalletPanel?'rgba(0,229,204,0.15)':'rgba(0,229,204,0.06)',border:'1px solid rgba(0,229,204,0.25)',cursor:'pointer',transition:'all 0.2s'}}>
              <span style={{fontSize:12}}></span>
              <span style={{fontSize:10,color:'#5a6a80',fontWeight:600}}>BOT</span>
              {realWallets.map(w => {
                const bal = (balances||{})[w.id] || 0;
                const unlocked = keypairs && keypairs[w.id];
                return (
                  <span key={w.id} style={{display:'flex',alignItems:'center',gap:3}}>
                    <span style={{width:5,height:5,borderRadius:'50%',background:unlocked?'#00e5cc':'#3a4a5a',display:'inline-block',boxShadow:unlocked?'0 0 4px #00e5cc':'none'}}/>
                    <span style={{fontSize:10,color:'#00e5cc',fontWeight:700,fontFamily:'monospace'}}>{bal.toFixed(3)}</span>
                  </span>
                );
              })}
              {realWallets.length===0&&<span style={{fontSize:9,color:'#3a4a5a'}}>+ wallet</span>}
            </div>
          </div>
          <div
            onClick={()=>setShowUserMenu(p=>!p)}
            style={{width:32,height:32,borderRadius:'50%',background:'linear-gradient(135deg,#00e5cc,#7c4dff)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,fontWeight:800,color:'#060809',cursor:'pointer',position:'relative',border:showUserMenu?'2px solid #00e5cc':'2px solid transparent',transition:'all 0.2s'}}
            title={user?.email||'Menu'}>
            {user?.email?.charAt(0).toUpperCase()||'?'}
            {profile?.is_admin && (
              <span style={{position:'absolute',top:-4,right:-4,fontSize:10,background:'#7c4dff',borderRadius:'50%',width:14,height:14,display:'flex',alignItems:'center',justifyContent:'center'}}></span>
            )}
          </div>
        </div>
      </header>{activeTab==='copytrade'?(
        <CopytradeTab walletAddress={walletAddress} curators={curators} onGoToNetwork={()=>setActiveTab('network')} botWallet={wallet} botLocked={locked}/>
      ):activeTab==='tracker'?(
        <TrackerTab solPrice={prices.sol} solChange={prices.solChange} pendingAddr={pendingAddr} onPendingHandled={()=>setPendingAddr(null)}/>
      ):activeTab==='wallets'?(
        <WalletsTab initialAddr={pendingWalletAddr} onInitialAddrUsed={()=>setPendingWalletAddr(null)}/>
      ):activeTab==='analytics'?(
        <AnalyticsTab/>
      ):activeTab==='network'?(
        <SnipersTab onAnalyzeWallet={handleAnalyzeWallet}/>
      ):(
      <div className="net-body">
        <aside className="net-sidebar-left">
          <div className="sidebar-section">
            <div className="sidebar-title">NAVIGATION</div>
            <button className={`sidebar-item ${activeNav==='feed'&&activeTab==='network'?'active':''}`} onClick={()=>{setActiveNav('feed');setActiveTab('network');}}>
              <svg viewBox="0 0 16 16"fill="none"width="14"height="14"><rect x="1"y="1"width="6"height="6"rx="1"fill="currentColor"opacity=".7"/><rect x="9"y="1"width="6"height="6"rx="1"fill="currentColor"opacity=".7"/><rect x="1"y="9"width="6"height="6"rx="1"fill="currentColor"opacity=".7"/><rect x="9"y="9"width="6"height="6"rx="1"fill="currentColor"opacity=".7"/></svg>
              Fil d'actualité
            </button>
            <button className={`sidebar-item ${activeNav==='dashboard'?'active':''}`} onClick={()=>setActiveNav('dashboard')}>
              <svg viewBox="0 0 16 16"fill="none"width="14"height="14"><path d="M2 8h5V2H2v6zm0 6h5v-4H2v4zm7 0h5v-6H9v6zm0-14v6h5V2H9z"fill="currentColor"opacity=".7"/></svg>
              Mon Dashboard
            </button>
            <button className={`sidebar-item ${activeNav==='abonnements'?'active':''}`} onClick={()=>setActiveNav('abonnements')}>
              <svg viewBox="0 0 16 16"fill="none"width="14"height="14"><circle cx="6"cy="5"r="3"stroke="currentColor"strokeWidth="1.3"opacity=".7"/><path d="M1 14a5 5 0 0 1 10 0"stroke="currentColor"strokeWidth="1.3"opacity=".7"/><path d="M12 7v4M14 9h-4"stroke="currentColor"strokeWidth="1.3"strokeLinecap="round"opacity=".7"/></svg>
              Mes Abonnements
              {curators.filter(c=>c.subscribed).length>0&&<span className="sidebar-badge">{curators.filter(c=>c.subscribed).length}</span>}
            </button>
          </div>
          {activeTab==='network'&&(
            <div className="sidebar-section">
              <div className="sidebar-title">FILTRES</div>
              <input className="sidebar-search"placeholder="Rechercher un curateur..."value={searchQuery} onChange={e=>setSearchQuery(e.target.value)}/>
              <div className="filter-group">
                <div className="filter-label">TYPE DE RÉSEAU</div>
                {[['tous','Tous les types'],['early','Acheteur précoce'],['gros','Gros portefeuille'],['acc','Accumulateur']].map(([val,label])=>(
                  <label key={val} className="filter-radio"><input type="radio"name="type"value={val} checked={filterType===val} onChange={()=>setFilterType(val)}/><span>{label}</span></label>
                ))}
              </div>
              <div className="filter-group">
                <div className="filter-label">SCORE ROI, MINIMUM</div>
                <input type="number"className="filter-input"value={minRoi} min={0} onChange={e=>setMinRoi(Number(e.target.value))}/>
              </div>
              <div className="filter-group">
                <div className="filter-label">COUVERTURE MINIMUM (%)</div>
                <input type="number"className="filter-input"defaultValue={0} min={0}/>
              </div>
              <div className="filter-group">
                <div className="filter-label">RISQUE</div>
                <div>{[['tous','Tous les types'],['rapide','Rapide'],['moyen','Moyen'],['lent','Lent']].map(([val,label])=>(<label key={val} className={`filter-tag ${filterRisque===val?'active':''}`} onClick={()=>setFilterRisque(val)}>{label}</label>))}</div>
              </div>
            </div>
          )}
        </aside>

        <main className="net-main">
          {activeTab==='network'&&(
            <>
              <div className="feed-header">
                <h2 className="feed-title">Fil d'actualité<span className="feed-count">{filtered.length}</span></h2>
                <div className="feed-header-right">
                  <div className="feed-tabs">{['recent','ancien','populaire'].map(t=>(<button key={t} className={`feed-tab ${feedTab===t?'active':''}`} onClick={()=>setFeedTab(t)}>{t.charAt(0).toUpperCase()+t.slice(1)}</button>))}</div>
                  <button className={`manage-btn ${manageMode?'active':''}`} onClick={()=>setManageMode(m=>!m)}>
                    <svg viewBox="0 0 16 16"fill="none"width="13"height="13"><path d="M2 4h12M2 8h12M2 12h12"stroke="currentColor"strokeWidth="1.5"strokeLinecap="round"/></svg>Gérer
                  </button>
                  <button className="add-btn"onClick={handleAdd}>
                    <svg viewBox="0 0 14 14"fill="none"width="12"height="12"><path d="M7 2v10M2 7h10"stroke="currentColor"strokeWidth="1.8"strokeLinecap="round"/></svg>Ajouter
                  </button>
                </div>
              </div>
              {filtered.length===0?(
                <div className="feed-empty">
                  <svg viewBox="0 0 40 40"fill="none"width="36"height="36"><circle cx="20"cy="20"r="16"stroke="#1e2530"strokeWidth="2"/><path d="M14 20h12M20 14v12"stroke="#2a3a50"strokeWidth="2"strokeLinecap="round"/></svg>
                  <div>Aucun curateur trouvé</div>
                  <button className="add-btn"onClick={handleAdd}>+ Ajouter un curateur</button>
                </div>
              ):(
                <div className="feed-list">
                  {filtered.map((c,i)=>(
                    <div key={c.id} className={`feed-card ${manageMode?'manage-mode':''}`}>
                      <div className="card-rank">{i+1}</div>
                      <div className="feed-card-inner">
                        <div className="feed-card-top">
                          <div className="feed-avatar"style={{background:c.avatarColor}}>{c.avatar}</div>
                          <div className="feed-info">
                            <div className="feed-name-row"><span className="feed-name">{c.name}</span><span className="feed-tag"style={{background:TAG_COLORS[c.tag]}}>{TAG_LABELS[c.tag]}</span></div>
                            <div className="feed-meta"><span className="feed-handle">{c.handle}</span><span className="feed-followers"><svg viewBox="0 0 12 12"fill="none"width="10"height="10"><circle cx="5"cy="4"r="2.5"stroke="currentColor"strokeWidth="1.1"/><path d="M1 11a4 4 0 0 1 8 0"stroke="currentColor"strokeWidth="1.1"/></svg>{c.followers}</span></div>
                          </div>
                          <div className="feed-card-actions">
                            {manageMode?(
                              <div className="manage-actions">
                                <button className="manage-edit-btn"onClick={()=>handleEdit(c)}><svg viewBox="0 0 14 14"fill="none"width="13"height="13"><path d="M9.5 2.5l2 2L5 11H3v-2l6.5-6.5z"stroke="currentColor"strokeWidth="1.2"strokeLinejoin="round"/></svg>Modifier</button>
                                <button className="manage-delete-btn"onClick={()=>handleDelete(c.id)}><svg viewBox="0 0 14 14"fill="none"width="13"height="13"><path d="M2 4h10M5 4V3h4v1M5 6v4M9 6v4M3 4l1 8h6l1-8"stroke="currentColor"strokeWidth="1.2"strokeLinecap="round"strokeLinejoin="round"/></svg>Supprimer</button>
                              </div>
                            ):(
                              <>
                                <span className="feed-prix">{c.prix.toFixed(1)}%</span>
                                <button className={`feed-btn ${c.subscribed?'manage':'subscribe'}`} onClick={()=>handleSubscribe(c.id)}>{c.subscribed?'Gérer':"S'abonner"}</button>
                              </>
                            )}
                          </div>
                        </div>
                        {!manageMode&&(
                          <>
                            <div className="feed-stats-grid">
                              <div className="feed-stats-left">
                                <div className="stat-row"><span className="stat-icon-wrap"><svg viewBox="0 0 14 14"fill="none"width="12"><circle cx="5"cy="4"r="2.5"stroke="#555"strokeWidth="1.2"/><path d="M1 13a5 5 0 0 1 10 0"stroke="#555"strokeWidth="1.2"/></svg></span><span className="stat-key">Abonnés</span><span className="stat-v">{c.abonnes}</span></div>
                                <div className="stat-row"><span className="stat-icon-wrap"><svg viewBox="0 0 14 14"fill="none"width="12"><rect x="1"y="3"width="12"height="8"rx="1.5"stroke="#555"strokeWidth="1.2"/><path d="M1 7h12"stroke="#555"strokeWidth="1.2"/></svg></span><span className="stat-key">Solde du réseau</span><span className="stat-v accent">{c.solde} SOL</span></div>
                                <div className="stat-row"><span className="stat-icon-wrap"><svg viewBox="0 0 14 14"fill="none"width="12"><path d="M7 1v12M1 7h12"stroke="#555"strokeWidth="1.2"strokeLinecap="round"/></svg></span><span className="stat-key">Couverture</span><span className="stat-v">{c.couverture}%</span></div>
                              </div>
                              <div className="feed-stats-right">
                                <div className="stat-row-r"><span className="stat-key">Tous de résultat</span><span className="stat-v muted">{c.touxResultat24h} SOL 24h</span></div>
                                <div className="stat-row-r"><span className="stat-key">Tous 24h</span><span className="stat-v muted">{c.tous24h}</span></div>
                                <div className="stat-row-r"><span className="stat-key">Taux de migration</span><span className="stat-v muted">{c.tauxMigration}%</span></div>
                              </div>
                            </div>
                            <div className="feed-card-footer">
                              <button className="footer-btn"><svg viewBox="0 0 14 14"fill="none"width="12"><rect x="1"y="1"width="12"height="12"rx="2"stroke="currentColor"strokeWidth="1.2"/><path d="M4 7h6M7 4v6"stroke="currentColor"strokeWidth="1.2"strokeLinecap="round"/></svg>Dashboard</button>
                              <button className="footer-btn"><svg viewBox="0 0 14 14"fill="none"width="12"><circle cx="10"cy="3"r="2"stroke="currentColor"strokeWidth="1.2"/><circle cx="10"cy="11"r="2"stroke="currentColor"strokeWidth="1.2"/><circle cx="3"cy="7"r="2"stroke="currentColor"strokeWidth="1.2"/><path d="M8.5 3.8L4.5 6.2M4.5 7.8l4 2.4"stroke="currentColor"strokeWidth="1.2"/></svg>Partager</button>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </main>

        <aside className="net-sidebar-right">
          {devMode&&<div className="dev-mode-banner"><span>‍</span> Mode Créateur</div>}
          <div className="right-section">
            <div className="right-title">STATS DU RÉSEAU</div>
            <div className="right-stat-row"><span>Curateurs</span><span className="right-val">{curators.length}</span></div>
            <div className="right-stat-row"><span>Total abonnés</span><span className="right-val">{totalAbonnes}</span></div>
            <div className="right-stat-row"><span>Vol 24h</span><span className="right-val">0 <span className="muted">SOL</span></span></div>
          </div>
          <div className="right-section">
            <div className="right-title">TOP ROI SCORE</div>
            {topRoi.map(w=>(<div key={w.id} className="right-rank-row"><div className="right-rank-avatar"style={{background:w.avatarColor}}>{w.avatar}</div><span className="right-rank-name">{w.name}</span><span className="right-rank-score">{w.roiScore} <span className="muted">pts</span></span></div>))}
          </div>
          <div className="right-section">
            <div className="right-title">MEILLEURE COUVERTURE</div>
            {[...curators].sort((a,b)=>parseFloat(b.couverture)-parseFloat(a.couverture)).slice(0,4).map(w=>(<div key={w.id} className="right-rank-row"><div className="right-rank-avatar"style={{background:w.avatarColor}}>{w.avatar}</div><span className="right-rank-name">{w.name}</span><span className="right-rank-score muted">{w.couverture}%</span></div>))}
          </div>
        </aside>
      </div>
      )}

      <footer className="net-footer">
        <div className="footer-left">
          <button className="footer-tab active"><svg viewBox="0 0 12 12"fill="none"width="10"><rect x="1"y="5"width="3"height="6"rx="1"fill="currentColor"/><rect x="5"y="3"width="3"height="8"rx="1"fill="currentColor"/><rect x="9"y="1"width="3"height="10"rx="1"fill="currentColor"/></svg>Position</button>
          <button className="footer-tab"><svg viewBox="0 0 12 12"fill="none"width="10"><circle cx="6"cy="6"r="4"stroke="currentColor"strokeWidth="1.2"/><path d="M6 4v2l1.5 1.5"stroke="currentColor"strokeWidth="1.2"strokeLinecap="round"/></svg>Détention</button>
          <button className="footer-tab"><svg viewBox="0 0 12 12"fill="none"width="10"><path d="M1 9l3-3 2 2 5-5"stroke="currentColor"strokeWidth="1.2"strokeLinecap="round"strokeLinejoin="round"/></svg>PnL</button>
        </div>
        <div className="footer-prices">
          <span className="fp"><span className="fp-coin">BTC</span><span>{fmtFooterPrice(prices.btc)}</span>{prices.loaded&&<span className={prices.btcChange>=0?'fp-pos':'fp-neg'}>{prices.btcChange>=0?'+':''}{prices.btcChange.toFixed(1)}%</span>}</span>
          <span className="fp"><span className="fp-coin">SOL</span><span>{fmtFooterPrice(prices.sol)}</span>{prices.loaded&&<span className={prices.solChange>=0?'fp-pos':'fp-neg'}>{prices.solChange>=0?'+':''}{prices.solChange.toFixed(1)}%</span>}</span>
          <span className="fp"><span className="fp-coin">ETH</span><span>{fmtFooterPrice(prices.eth)}</span>{prices.loaded&&<span className={prices.ethChange>=0?'fp-pos':'fp-neg'}>{prices.ethChange>=0?'+':''}{prices.ethChange.toFixed(1)}%</span>}</span>
        </div>
        <div className="footer-right">
          <span className="footer-latency">0s</span><span className="footer-sep">|</span><span className="footer-tx">0 TX/s</span>
          <div className="footer-speed-badge"><svg viewBox="0 0 16 16"fill="none"width="11"><path d="M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2zm0 2v4l3 1.5"stroke="#00e5cc"strokeWidth="1.3"strokeLinecap="round"/></svg>94</div>
        </div>
      </footer>
    </div>
  );
}